import { render, staticRenderFns } from "./LinkMainColor.vue?vue&type=template&id=5db4992d&scoped=true&"
import script from "./LinkMainColor.vue?vue&type=script&lang=js&"
export * from "./LinkMainColor.vue?vue&type=script&lang=js&"
import style0 from "./LinkMainColor.vue?vue&type=style&index=0&id=5db4992d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db4992d",
  null
  
)

export default component.exports